import * as React from 'react';
import Button from '@mui/material/Button';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../lib/api';
import { AuthContext } from '../../authContext/context';
import { useContext, useState, useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

export default function ChangeGroupCode() {
  const authCtx = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [groupCodes, setGroupCodes] = useState([]);
  const [selectedCode, setSelectedCode] = useState('');

  // Support both old and new state structures
  const lead_id = location?.state?.leadId || location?.state?.id; 
  const title = location?.state?.title || '';
  const returnUrl = location?.state?.returnUrl;
  const currentGroupCode = location?.state?.currentGroupCode;
  
  console.log('ChangeGroupCode state received:', location.state);

  useEffect(() => {
    const fetchGroupCodes = async () => {
      try {
        const res = await postRequest('private/getGroupCodeList', {}, authCtx.token);
        if (res?.status === 200 && Array.isArray(res?.data)) {
          setGroupCodes(res.data);
        }
      } catch (err) {
        console.error("Failed to fetch group codes:", err);
      }
    };

    const fetchCurrentGroupCode = async () => {
      // If currentGroupCode is passed from the previous page, use it
      if (currentGroupCode) {
        // Extract _id if currentGroupCode is an object, otherwise use it directly
        const groupCodeId = typeof currentGroupCode === 'object' ? (currentGroupCode._id || currentGroupCode) : currentGroupCode;
        console.log('Setting current group code:', groupCodeId, 'from:', currentGroupCode);
        setSelectedCode(groupCodeId);
        return;
      }
      
      if (!lead_id) return;
      try {
        const res = await postRequest(`private/getGroupCodeById/${lead_id}`, {}, authCtx.token);
        if (res?.status === 200 && res.data?.group_code) {
          // Extract _id if group_code is an object, otherwise use it directly
          const groupCodeId = typeof res.data.group_code === 'object' ? (res.data.group_code._id || res.data.group_code) : res.data.group_code;
          console.log('Fetched group code from API:', groupCodeId, 'from:', res.data.group_code);
          setSelectedCode(groupCodeId);
        }
      } catch (err) {
        console.error("Failed to fetch current group code:", err);
      }
    };

    fetchGroupCodes();
    fetchCurrentGroupCode();
  }, [lead_id, authCtx.token, currentGroupCode]);

  const handleChange = (event) => {
    setSelectedCode(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log('Submit clicked with:', { selectedCode, lead_id });
    
    if (!selectedCode || !lead_id) {
      console.error('Missing data:', { selectedCode, lead_id });
      Swal.fire('Error', 'Please select a group code and ensure lead ID exists.', 'error');
      return;
    }
    console.log('Submitting:', selectedCode, lead_id)


    try {
      const payload = {
        lead_id: lead_id,
        group_code: selectedCode,
      };

      const res = await postRequest('private/change-group-code', payload, authCtx.token);

      if (res?.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: res?.message || 'Group code updated successfully.',
          timer: 1500,
          showConfirmButton: false
        });
       
        // Navigate back to return URL or construct the view URL
        setTimeout(() => {
          if (returnUrl) {
            navigate(returnUrl);
          } else {
            navigate(`/leads/view/${title}/${lead_id}`);
          }
        }, 1500);
      } else {
        Swal.fire('Error', res?.message || 'Something went wrong.', 'error');
      }
    } catch (err) {
      console.error('Submission error:', err);
      Swal.fire('Error', 'Internal server error.', 'error');
    }
  };

  return (
    <>
      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>Change Group Code</h1>
        {lead_id && <p className='text-muted'>Lead ID: #{lead_id}</p>}
      </div>

      <div className='page-top-formview mb-3'>
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col xs={7}>
              <Form.Group controlId="searchId">
                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined">
                  <InputLabel id="group-code-select-label">Group Code</InputLabel>
                  <Select
                    labelId="group-code-select-label"
                    id="group-code-select"
                    value={selectedCode}
                    onChange={handleChange}
                    label="Group Code"
                  >
                    {groupCodes.map((group) => (
                   <MenuItem key={group._id} value={group._id}>
  {group.name}
</MenuItem>

                    ))}
                  </Select>
                </FormControl>
              </Form.Group>
            </Col>

            <Col xs={7} className='gap-3 d-flex mt-2'>
              <Button 
                variant="outlined" 
                className='red-outline-btn text-capitalize h-56'
                onClick={() => navigate(returnUrl || `/leads/view/${title}/${lead_id}`)}
              >
                Cancel
              </Button>

              <Button variant="contained" type="submit" className='red-bg red-button text-capitalize h-56'>
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
}
